var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.5 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0-1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m4.265 6a4.52 4.52 0 0 0-4.265-3 4.52 4.52 0 0 0-4.265 3zm1.05 0a5.52 5.52 0 0 0-5.315-4 5.52 5.52 0 0 0-5.315 4A5.5 5.5 0 0 0 5 16h11a5.5 5.5 0 0 0-.185-1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.5 8q.396.001.776.055c.157.424.375.818.645 1.172A4.5 4.5 0 0 0 5.5 9a4.52 4.52 0 0 0-4.266 3h4.578a6.5 6.5 0 0 0-.788 1H0a5.5 5.5 0 0 1 .186-1A5.52 5.52 0 0 1 5.5 8M5.5 0a3.5 3.5 0 0 1 3.3 2.333 4.5 4.5 0 0 0-.896.491A2.498 2.498 0 0 0 3 3.5a2.5 2.5 0 0 0 3.035 2.44 4.5 4.5 0 0 0-.012 1.02Q5.767 7 5.5 7a3.5 3.5 0 1 1 0-7"
})));
export default SvgUserGroup;